export default "__VITE_ASSET__e493f5ea__"